import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import uniq from 'lodash/uniq';

import { Button, Modal, Textarea } from 'components/ui';

import * as Styled from './InviteUserModal.styles';

export const InviteUserModal = ({ existingEmails, onClose, onConfirm, isSaving }) => {
  const [textareaValue, setTextareaValue] = useState('');
  const [errors, setErrors] = useState([]);

  const handleInvite = () => {
    const emails = uniq(
      textareaValue
        .trim()
        .split(',')
        .map((email) => email.trim())
        .filter((email) => email),
    );

    const errorMessages = emails.reduce((acc, email) => {
      try {
        Yup.string().email('niepoprawny adres e-mail').validateSync(email);
      } catch (err) {
        return [...acc, { email, message: err.message }];
      }

      if (existingEmails.includes(email)) {
        return [...acc, { email, message: 'adres e-mail już istnieje' }];
      }

      return acc;
    }, []);

    setErrors(errorMessages);

    if (errors.length === 0) {
      onConfirm(emails);
    }
  };

  return (
    <Modal title="Zaproś użytkowników do swojej organizacji" onClose={onClose}>
      <Styled.Message>
        Podaj adresy email użytkowników, których chesz zaprosić do dołączenia do Twojej organizacji. Adresy email
        oddziel od siebie przecinkiem “,”
      </Styled.Message>

      <Textarea label="Adres email*" onChange={setTextareaValue} value={textareaValue} />
      {errors.length > 0 && (
        <Styled.Errors>
          {errors.map((error, index) => (
            <div key={`${index}-${error.email}`}>
              <strong>{error.email}</strong>: {error.message}
            </div>
          ))}
        </Styled.Errors>
      )}

      <Styled.Actions>
        <Button onClick={onClose} variant="outlined">
          Anuluj
        </Button>
        <Button onClick={handleInvite} loading={isSaving}>
          Wyślij zaproszenie
        </Button>
      </Styled.Actions>
    </Modal>
  );
};

InviteUserModal.propTypes = {
  existingEmails: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
};
